module.exports = __webpack_public_path__ + "img/yy5.f390d3b8.png";